
import React, { Component } from "react";
import { Center, Text } from "@chakra-ui/react";
import {parseISO, format} from "date-fns";


export default class BaseDisplay extends Component {


    render() 
    {

        var displayValue = this.props.cardValue;
        if ((this.props.card.display) && (this.props.card.display.type === "datetime") && (this.props.card.display.format))
        {
            // assumes dates are in ISO string format
            var dt = parseISO(displayValue);
            displayValue = format(dt, this.props.card.display.format);
        }
        return (
            <Center>
                <Text fontSize={{ base: '14px', md: '20px', lg: '24px' }} color="white" margin='0' overflowWrap={"anywhere"}>{displayValue}</Text>
            </Center>
        )
    }
}








